module.exports = { "default": require("core-js/library/fn/object/seal"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/seal.js
// module id = 652
// module chunks = 1